import { c as _c } from "react/compiler-runtime";
import { useCountdown } from '@onefootprint/hooks';
import { LinkButton, LoadingSpinner } from '@onefootprint/ui';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TOUCH_TARGET_CLASS } from '@/idv2/components/constants';
type ResendButtonProps = {
  onResend: () => void;
  isResendLoading?: boolean;
  resendDisabledUntil?: Date;
  showLegalFooter?: boolean;
};
export const ResendButton = t0 => {
  const $ = _c(28);
  const {
    onResend,
    isResendLoading: t1,
    resendDisabledUntil,
    showLegalFooter: t2
  } = t0;
  const isResendLoading = t1 === undefined ? false : t1;
  const showLegalFooter = t2 === undefined ? true : t2;
  const {
    t
  } = useTranslation("idv2");
  const {
    setDate,
    countdown
  } = useCountdown();
  const [resendClicked, setResendClicked] = useState(false);
  const [internalDate, setInternalDate] = useState();
  let t3;
  let t4;
  if ($[0] !== internalDate || $[1] !== resendDisabledUntil || $[2] !== setDate) {
    t3 = () => {
      if (internalDate === resendDisabledUntil) {
        return;
      }
      setInternalDate(resendDisabledUntil);
      setResendClicked(false);
      if (!resendDisabledUntil) {
        setDate(new Date());
        return;
      }
      setDate(resendDisabledUntil);
    };
    t4 = [resendDisabledUntil, internalDate, setDate];
    $[0] = internalDate;
    $[1] = resendDisabledUntil;
    $[2] = setDate;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== countdown || $[6] !== onResend) {
    t5 = () => {
      setResendClicked(true);
      if (countdown > 0) {
        return;
      }
      onResend();
    };
    $[5] = countdown;
    $[6] = onResend;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleClick = t5;
  let t6;
  if ($[8] !== countdown || $[9] !== handleClick || $[10] !== isResendLoading || $[11] !== resendClicked || $[12] !== t) {
    t6 = isResendLoading ? <LoadingSpinner /> : <LinkButton className={TOUCH_TARGET_CLASS} onClick={handleClick} disabled={resendClicked && countdown > 0} aria-label={t(_temp)} data-dd-action-name="pin:resend">{t(_temp2)}</LinkButton>;
    $[8] = countdown;
    $[9] = handleClick;
    $[10] = isResendLoading;
    $[11] = resendClicked;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== countdown || $[15] !== resendClicked || $[16] !== t) {
    t7 = resendClicked && countdown > 0 && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 10
    }} className="text-body-2 text-tertiary">{t(_temp3).replace("{{seconds}}", String(countdown))}</motion.div>;
    $[14] = countdown;
    $[15] = resendClicked;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <AnimatePresence>{t7}</AnimatePresence>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <div className="flex flex-col items-center justify-center gap-1">{t6}{t8}</div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== showLegalFooter) {
    t10 = showLegalFooter && <><hr className="border-tertiary" /><p className="text-caption-2 text-tertiary text-center"><Trans ns="idv2" i18nKey={_temp4} components={{
          termsLink: <a href="https://www.onefootprint.com/terms-of-service" rel="noopener noreferrer" target="_blank" className="text-accent">{" "}</a>,
          privacyPolicyLink: <a href="https://www.onefootprint.com/privacy-policy" rel="noopener noreferrer" target="_blank" className="text-accent">{" "}</a>
        }} /></p></>;
    $[23] = showLegalFooter;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = <div className="w-full flex flex-col gap-4">{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default ResendButton;
function _temp($) {
  return $.identify.otp.resendCode;
}
function _temp2($_0) {
  return $_0.identify.otp.resendCode;
}
function _temp3($_1) {
  return $_1.identify.otp.resendCountdown;
}
function _temp4($_2) {
  return $_2.identify.otp.legalFooter;
}